import { useHotelsListApi } from '@/features/hotels/hooks/useHotelsListApi';
import { FC, useEffect } from 'react';
import NotificationCreateStep1Element from './NotificationCreateStep1Element';
import { GetHotelListItemDto } from '@/features/hotels/types/hotels-dto';
import { UseFormSetValue } from 'react-hook-form';
import { NotificationCreateFormData } from '@/features/notifications/validators/NotificationCreateValidator';
import { t } from 'i18next';

type Props = {
	hotels: GetHotelListItemDto[];
	setHotels: (ids: GetHotelListItemDto[]) => void;
	setValue: UseFormSetValue<NotificationCreateFormData>;
};

const NotificationCreateStep1: FC<Props> = ({ hotels, setHotels, setValue }) => {
	const { hotelsListData } = useHotelsListApi();

	useEffect(() => {
		hotels.forEach((hotel, index) => {
			setValue(`hotels.${index}`, {
				hotelId: hotel.id,
				allApartments: false,
				apartmentIds: [],
			});
		});
	}, [hotels, setValue]);

	const handleElementCheck = (selectedHotel: GetHotelListItemDto) => {
		const hotelIncluded = hotels.find(
			(hotel) => hotel.id === selectedHotel.id,
		);

		hotelIncluded
			? setHotels(hotels.filter((hotel) => hotel.id !== selectedHotel.id))
			: setHotels([...hotels, selectedHotel]);
	};

	const selectedAll = hotelsListData?.totalCount === hotels.length;

	const handleAllElementsCheck = () => {
		if (selectedAll) {
			setHotels([]);
		} else {
			setHotels(hotelsListData?.items || []);
		}
	};

	return (
		<div className='flex flex-col gap-4 overflow-y-auto'>
			<NotificationCreateStep1Element
				text={t('main.notifications.components.create.steps.step1Label')}
				checked={selectedAll}
				onClick={handleAllElementsCheck}
			/>
			{hotelsListData?.items?.map((hotel) => (
				<NotificationCreateStep1Element
					key={hotel.id}
					text={hotel.name ?? ''}
					checked={!!hotels.find(({ id }) => id === hotel.id)}
					onClick={() => handleElementCheck(hotel)}
				/>
			))}
		</div>
	);
};

export default NotificationCreateStep1;
